import { changeDateFormat } from "../Custom";
import { generateListingReport } from "./PendencyReport/ExportaPendencyReportExcel";

export const formatGrossValueForAsiListing = (value) => {
  if (value === 0) return "0.00";
  if (value === "NaN") return "";
  if (value === "" || value === null) return value;
  return Number(value).toFixed(2);
};

/** Builds multi-sheet ASI listing Excel (Blocks A–L); same payload as ASI Listing Report API. */
export const downloadAsiListingExcelReport = (allData, dslNo, yearName) => {
  const formatGrossValue = formatGrossValueForAsiListing;

  let blockAData = allData.asiListingA.map((item, index) => [
    index + 1,
    item.regionName,
    item.divisionName,
    item.districtName,
    item.dsl_No,
    item.surveyYear,
    item.psl_No,
    item.schemeCode,
    item.nicCodePerreturn,
    item.sector,
    item.number_Of_Unit,
    item.status_Of_Unitcode,
    item.reason,
  ]);

  let blockAStructure = {
    sheetName: "BlockA",
    firstRowMergeCells: "A1:M1",
    firstRowExportDate: changeDateFormat(new Date()),
    secondRowMergeCells: "A2:M2",
    secondRowText: `Annual Survey of Industries, Uttar Pradesh`,
    thirdRowMergeCells: "A3:M3",
    thirdRowText: `Block 'A':Identification particulars`,
    headerEnglishColumns: [
      "S.No",
      "REGION NAME",
      "DIVISION NAME",
      "DISTRICT NAME",
      "DSL_NO",
      "SURVEY YEAR",
      "PSL_NO",
      "SCHEME CODE",
      "NIC CODE PERRETURN",
      "SECTOR",
      "NUMBER_OF_UNIT",
      "STATUS_OF_UNITCODE",
      "REASON",
    ],
    excelRowData: blockAData,
  };

  let blockBData = allData.asiListingB.map((item, index) => [
    index + 1,
    item.dsl_No,
    item.surveyYear,
    item.typeOrganizationCod,
    item.typeOwnershipCode,
    item.isoCertification14000,
    item.yearInitialProductio,
    item.accountingYear,
    item.numberMonthsofOperation,
    item.computerizedAccountingSyst,
    item.asiDataComputerMedi,
  ]);

  let blockBStructure = {
    sheetName: "BlockB",
    firstRowMergeCells: "A1:K1",
    firstRowExportDate: changeDateFormat(new Date()),
    secondRowMergeCells: "A2:K2",
    secondRowText: `Annual Survey of Industries, Uttar Pradesh`,
    thirdRowMergeCells: "A3:K3",
    thirdRowText: `Block 'B':Particulars of the factory`,
    headerEnglishColumns: [
      "S.No",
      "DSL_NO",
      "SURVEY_YEAR",
      "TYPE_ORGANIZATION_COD",
      "TYPE_OWNERSHIP_CODE",
      "ISO_CERTIFICATION_14000",
      "YEAR_INITIAL_PRODUCTIO",
      "ACCOUNTING_YEAR",
      "NUMBER_MONTHSOF_OPERATION",
      "COMPUTERIZED_ACCOUNTING_SYST",
      "ASI_DATA_COMPUTER_MEDI",
    ],
    excelRowData: blockBData,
  };

  let blockCData = allData.asiListingC.map((item, index) => [
    index + 1,
    item.Asset3_56_,
    item.GrossValueOpeningAson,
    formatGrossValue(item.AdditionYearRevaluation),
    formatGrossValue(item.AdditionDuringYearActual),
    formatGrossValue(item.DeductionAdjDuringYear),
    formatGrossValue(item.ClosingTotal),
    formatGrossValue(item.DepreciationUptoYrbgng),
    formatGrossValue(item.DepreciationProvidedDuringyr),
    formatGrossValue(item.DepreciationAdjustment),
    formatGrossValue(item.uptoYearEndTotal),
    formatGrossValue(item.OpeningAsDifference),
    formatGrossValue(item.ClosingAsDifference),
  ]);

  let blockCStructure = {
    sheetName: "BlockC",
    firstRowMergeCells: "A1:M1",
    firstRowExportDate: changeDateFormat(new Date()),
    secondRowMergeCells: "A2:M2",
    secondRowText: `Annual Survey of Industries, Uttar Pradesh`,
    thirdRowMergeCells: "A3:M3",
    thirdRowText: `Block 'C':Fixed Assets`,
    headerEnglishColumns: [
      "S.No",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ],
    excelRowData: blockCData,
  };

  let blockDData = allData.asiListingD.map((item, index) => [
    index + 1,
    item.ASSET3_56_,
    formatGrossValue(item.Opening_Amount),
    formatGrossValue(item.Closing_Amount),
  ]);

  let blockDStructure = {
    sheetName: "BlockD",
    firstRowMergeCells: "A1:D1",
    firstRowExportDate: changeDateFormat(new Date()),
    secondRowMergeCells: "A2:D2",
    secondRowText: `Annual Survey of Industries, Uttar Pradesh`,
    thirdRowMergeCells: "A3:D3",
    thirdRowText: `Block 'D':Working Capital and Loans`,
    headerEnglishColumns: ["S.No", "Items", "Opening (Rs.)", "Closing (Rs.)"],
    excelRowData: blockDData,
  };

  let blockEData = allData.asiListingE.map((item, index) => [
    index + 1,
    item.Asset3_56_,
    item.manufacturing,
    item.nonmanufacturing,
    item.Total,
    item.AvgNoPersonsWorked,
    item.NoMandaysPaid,
    item.WagesOrSalaries,
  ]);

  let blockEStructure = {
    sheetName: "BlockE",
    firstRowMergeCells: "A1:H1",
    firstRowExportDate: changeDateFormat(new Date()),
    secondRowMergeCells: "A2:H2",
    secondRowText: `Annual Survey of Industries, Uttar Pradesh`,
    thirdRowMergeCells: "A3:H3",
    thirdRowText: `Block 'E':Employement and Labour Cost`,
    headerEnglishColumns: [
      "S.No",
      "Category of staff",
      "Manufacturing",
      "Non Manufacturing",
      "Total",
      "Average No. of persons worked  ",
      "No. of mandays paid",
      "Wages/Salarie",
    ],
    excelRowData: blockEData,
  };

  let blockFData = allData.asiListingF.map((item, index) => [
    index + 1,
    item.Asset3_56_,
    item.expenditure,
  ]);

  let blockFStructure = {
    sheetName: "BlockF",
    firstRowMergeCells: "A1:C1",
    firstRowExportDate: changeDateFormat(new Date()),
    secondRowMergeCells: "A2:C2",
    secondRowText: `Annual Survey of Industries, Uttar Pradesh`,
    thirdRowMergeCells: "A3:C3",
    thirdRowText: `Block 'F':Other Expenses`,
    headerEnglishColumns: ["S.No", "Item", "Expenditure"],
    excelRowData: blockFData,
  };

  let blockGData = allData.asiListingG.map((item, index) => [
    index + 1,
    item.Items,
    formatGrossValue(item.Receipts),
  ]);

  let blockGStructure = {
    sheetName: "BlockG",
    firstRowMergeCells: "A1:C1",
    firstRowExportDate: changeDateFormat(new Date()),
    secondRowMergeCells: "A2:C2",
    secondRowText: `Annual Survey of Industries, Uttar Pradesh`,
    thirdRowMergeCells: "A3:C3",
    thirdRowText: `Block 'G':Other Output/Receipts`,
    headerEnglishColumns: ["S.No", "Items", "Receipts (in Rs.)"],
    excelRowData: blockGData,
  };

  let blockHData = allData.asiListingH.map((item, index) => [
    index + 1,
    item.Itemdescription,
    item.ItemCode,
    item.Unitofquantity,
    formatGrossValue(item.Quantity),
    item.Purchasevalue,
    item.RateperUnit,
  ]);

  let blockHStructure = {
    sheetName: "BlockH",
    firstRowMergeCells: "A1:G1",
    firstRowExportDate: changeDateFormat(new Date()),
    secondRowMergeCells: "A2:G2",
    secondRowText: `Annual Survey of Industries, Uttar Pradesh`,
    thirdRowMergeCells: "A3:G3",
    thirdRowText: `Block 'H':Indigenous input items consumed`,
    headerEnglishColumns: [
      "S.No",
      "Item description (Major Ten Basic items",
      "Item Code",
      "Unit of quantity",
      "Quantity",
      "Purchase value (in Rs)",
      "Rate per Unit (in Rs)",
    ],
    excelRowData: blockHData,
  };

  let blockIData = allData.asiListingI.map((item, index) => [
    index + 1,
    item.ItemDesc,
    item.ItemCode,
    item.UnitOfQty,
    formatGrossValue(item.QtyConsumed),
    item.PurchaseValue,
    formatGrossValue(item.RatePerUnit),
  ]);

  let blockIStructure = {
    sheetName: "BlockI",
    firstRowMergeCells: "A1:G1",
    firstRowExportDate: changeDateFormat(new Date()),
    secondRowMergeCells: "A2:G2",
    secondRowText: `Annual Survey of Industries, Uttar Pradesh`,
    thirdRowMergeCells: "A3:G3",
    thirdRowText: `Block 'I':Imported input items consumed - directly only`,
    headerEnglishColumns: [
      "S.No",
      "Item description(Major Ten Basic items",
      "Item Code",
      "Unit of quantity",
      "Quantity",
      "Purchase value (in Rs)",
      "Rate per Unit (in Rs)",
    ],
    excelRowData: blockIData,
  };

  let blockJData = allData.asiListingJ.map((item, index) => [
    index + 1,
    item.ProductByproductDesc,
    item.ItemCode,
    item.UnitOfQty,
    formatGrossValue(item.QtyManufactured),
    formatGrossValue(item.QtySold),
    formatGrossValue(item.GrossSaleValue),
    item.DistributiveExpensesExcise_Duty,
    item.DistributiveExpensesSales_Tax_Vat,
    item.DistributiveExpensesOthers,
    item.DistributiveExpensesTotal,
    formatGrossValue(item.perUnitNetSaleValue),
    formatGrossValue(item.exFactoryValueOfQty),
  ]);

  let blockJStructure = {
    sheetName: "BlockJ",
    firstRowMergeCells: "A1:M1",
    firstRowExportDate: changeDateFormat(new Date()),
    secondRowMergeCells: "A2:M2",
    secondRowText: `Annual Survey of Industries, Uttar Pradesh`,
    thirdRowMergeCells: "A3:M3",
    thirdRowText: `Block 'J':Products and By-Products manufactured by the unit`,
    headerEnglishColumns: [
      "S.No",
      "Product/By-product descriptions(First ten ",
      "Item Code(NPCMS)",
      "Unit of Qty",
      "Qty. Manufactured ",
      "Qty. sold",
      "Gross sale Value(Rs.)(including subsidy received)",
      "Distributive expenses(Rs.)",
      "",
      "",
      "",
      "(Per unit net sale value(Rs.0.00) (col. 7 -col.11)/col. 6",
      "Ex-Factory Value of Qty.(col. 12 * col. 5) ",
    ],
    excelRowData: blockJData,
  };

  let blockKData = allData.asiListingK.map((item, index) => [
    index + 1,
    item.ICTIndicator,
    item.Code === "" ? "No" : "YES",
  ]);

  let blockKStructure = {
    sheetName: "BlockK",
    firstRowMergeCells: "A1:C1",
    firstRowExportDate: changeDateFormat(new Date()),
    secondRowMergeCells: "A2:C2",
    secondRowText: `Annual Survey of Industries, Uttar Pradesh`,
    thirdRowMergeCells: "A3:C3",
    thirdRowText: `Block 'K':Information and Communication Technology(ICT) USAGE`,
    headerEnglishColumns: ["S.No", "ICT Indicator", "Code"],
    excelRowData: blockKData,
  };

  let blockLData = allData.asiListingL.map((item, index) => [
    index + 1,
    item.ECndicator,
    item.Code === "" ? "No" : "YES",
  ]);

  let blockLStructure = {
    otherData: allData.asiListingL.length > 0 ? allData.asiListingL[0] : [],
    sheetName: "BlockL",
    firstRowMergeCells: "A1:C1",
    firstRowExportDate: changeDateFormat(new Date()),
    secondRowMergeCells: "A2:C2",
    secondRowText: `Annual Survey of Industries, Uttar Pradesh`,
    thirdRowMergeCells: "A3:C3",
    thirdRowText: `Block 'L':Energy Conservation(EC) Measures`,
    headerEnglishColumns: ["S.No", "EC Indicator", "Code"],
    excelRowData: blockLData,
  };

  let finalObject = {
    excelObjectData: [
      blockAStructure,
      blockBStructure,
      blockCStructure,
      blockDStructure,
      blockEStructure,
      blockFStructure,
      blockGStructure,
      blockHStructure,
      blockIStructure,
      blockJStructure,
      blockKStructure,
      blockLStructure,
    ],
    fileName: "ASIListReport.xls",
    dslNo: dslNo,
    yearName: yearName,
  };

  generateListingReport(finalObject);
};
